module.exports = __webpack_public_path__ + "static/media/icon-oferta-imoveis.a082b966.svg";